import React from 'react';

interface IProps {
    style?: any;
    fill?: string;
    width?: string;
    height?: string;
}

export const UnlockedIcon: React.FC<IProps> = (props: IProps) => {
    return (
        <svg width={props.width??"18"} height={props.height??"17"} viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg" style={props.style}>
        <path d="M13.5 0C11.0151 0 9 2.11461 9 4.72222V7.55556H0.9C0.405 7.55556 0 7.98056 0 8.5V16.0556C0 16.575 0.405 17 0.9 17H11.7C12.195 17 12.6 16.575 12.6 16.0556V8.5C12.6 7.98056 12.195 7.55556 11.7 7.55556H10.8V4.72222C10.8 3.15728 12.0087 1.88889 13.5 1.88889C14.9913 1.88889 16.2 3.15728 16.2 4.72222V6.61111C16.2 7.13339 16.6032 7.55556 17.1 7.55556C17.5968 7.55556 18 7.13339 18 6.61111V4.72222C18 2.11461 15.9849 0 13.5 0Z" fill={props.fill??"#CCCCCC"}/>
        </svg>       
    )
}

export default UnlockedIcon;